module.exports = __webpack_public_path__ + "static/img/coupon-invalid-bg.cb92ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new-user/coupon-invalid-bg.png
// module id = gm6Q
// module chunks = 4